import styled, { css } from 'styled-components';
import { gentleBlinking } from '../MorphingCaret/styles';

export const StyledDropdownContainer = styled.div<{
  isDimmed: boolean;
  isTemporary: boolean;
  isStatic?: boolean;
}>`
  position: relative;
  display: inline-flex;
  border-radius: var(--cl-radius-1);
  transition: background-color 150ms ease, box-shadow 150ms ease;

  /* nothing to configure here, so it does not invite a click */
  ${({ isStatic }) => (isStatic && css`
    pointer-events: none;
  `)}

  &:focus,
  &:focus-visible {
    outline: none;
    background-color: var(--cl-yellow-200);
  }

  ${({ isDimmed }) => (isDimmed
    && css`
      opacity: 0.5;
      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
      }
    `)}

  ${({ isTemporary }) => (isTemporary
    && css`
      color: var(--cl-yellow-600);
      animation: ${gentleBlinking} 1000ms ease infinite;
    `)}
`;
